import React, { useMemo } from 'react';
import { computeWordDiffParts } from './PromptDiffView';
import './PromptEditor.css';

/**
 * Shows the new/proposal text with subtle blue highlighting on inserted/changed words.
 */
export default function PromptProposalView({
  oldText = '',
  newText = '',
  parts = null,
  className = '',
}) {
  const diffParts = useMemo(
    () => computeWordDiffParts(oldText, newText),
    [oldText, newText, parts],
  );

  return (
    <div className={`prompt-proposal-view ${className}`}>
      {diffParts.map((part, i) => {
        if (part.removed) return null;
        if (part.added) {
          return (
            <span key={i} className="prompt-proposal-highlight">
              {part.value}
            </span>
          );
        }
        return <span key={i}>{part.value}</span>;
      })}
    </div>
  );
}
